import { cn } from '@navinc/base-react-components'
import { Icon } from '@navinc/base-react-components/wayfinder'

import { cmsGraphql, FragmentType, getFragmentData } from '../../lib/cms/index.js'

export const prosConsTypename = 'CmsProsConsBlock'

export const prosConsFragment = cmsGraphql(/* GraphQL */ `
  fragment prosConsFragment on CmsProsConsBlock {
    pros
    cons
  }
`)

export type prosConsProps = {
  data: FragmentType<typeof prosConsFragment>
}

const ProCon = ({ type, content }: { type: 'pros' | 'cons'; content: string }) => {
  const isPros = type === 'pros'
  const bullets = content
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
  return (
    <div className="col-span-1 flex grow flex-col gap-75 rounded-200 border border-outlineVariant p-300">
      <div className={cn('flex flex-row gap-100 items-center', isPros ? 'text-successBright' : 'text-error')}>
        <Icon name={isPros ? 'add_circle' : 'do_not_disturb_on'} />
        <p className="body1-emphasized">{isPros ? 'Pros' : 'Cons'}</p>
      </div>
      <ul className="body1 ml-[50px] list-disc text-onSurface">
        {bullets.map((bullet, index) => (
          <li key={index} className="my-50">
            {bullet}
          </li>
        ))}
      </ul>
    </div>
  )
}

export const ProsCons = ({ data }: prosConsProps) => {
  const { pros, cons } = getFragmentData(prosConsFragment, data)

  return (
    <div className={cn('grid grid-cols-1 gap-300 pb-300 tablet:pb-600', pros && cons && 'tablet:grid-cols-2')}>
      {pros && <ProCon type="pros" content={pros} />}
      {cons && <ProCon type="cons" content={cons} />}
    </div>
  )
}
